import { getAPI } from "../helpers/httpHelper";
import { API_ADMIN_CONTRATISTA_SUBCONTRATISTA, URL_SUPPORT } from "../helpers/variableHelper";

export default class CscService {
  constructor() {
    console.log("")
  }  

  public static async getAll(token: string, params: any) {
    let result = await getAPI(
      `${URL_SUPPORT}${API_ADMIN_CONTRATISTA_SUBCONTRATISTA}/getall`,
      { Authorization: `Bearer ${token}` },
      params
    );
    return result;
  }
}
